// src/components/Profile/AddressSection.jsx
import React from 'react';

export default function AddressSection({ addresses, onAddNew, onEdit, onDelete }) {
  return (
    <div className="profile-card card-animate">
      <div className="profile-header">
        <h3>My Addresses</h3>
      </div>

      <div className="address-list">
        {addresses.length > 0 ? (
          addresses.map((address) => (
            <div key={address.id} className="address-item">
              <div className="address-type">
                <i className="ph ph-map-pin"></i>
                <span>{address.address_data?.addressLabel || 'Address'}</span>
              </div>
              <p>
                <strong>{address.address_data?.fullName}</strong><br />
                {address.address_data?.streetAddress}<br />
                {address.address_data?.city}, {address.address_data?.province} {address.address_data?.postalCode}<br />
                {address.address_data?.phone}
              </p>
              <div className="address-actions">
                <button className="btn-icon" onClick={() => onEdit(address)}>
                  <i className="ph ph-pencil-simple"></i>
                </button>
                <button className="btn-icon" onClick={() => onDelete(address.id)}>
                  <i className="ph ph-trash"></i>
                </button>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-gray-500">No saved addresses</p>
        )}
      </div>

      <button className="add-new-btn" onClick={onAddNew}>
        <i className="ph ph-plus"></i> Add New Address
      </button>
    </div>
  );
}